import React, { useEffect, useState } from 'react'
import Alert from './Alert';
import N from '../assets/events.json';

export default function PastNotifications(props) {
    const val = parseInt(props.length);
    const [alerts, setAlerts] = useState([]);
    const [pastAlerts, setPastAlerts] = useState([]);

    const initData = function () {
        //PAST
        var pastAlertsData = [];
        for (let i = 0; i < N.length; i++) {
            var now = new Date();
            if (new Date(N[i].endDateTime) <= now) {
                pastAlertsData.push(
                    <Alert key={N[i].key} timeRange={N[i].timeRange} dateRange={N[i].dateRange} innerText={N[i].innerText} title={N[i].title} ></Alert>
                )
            }
        }
        if (!isNaN(val)) {
            pastAlertsData = pastAlertsData.slice(0, val);
        }
        setPastAlerts(pastAlertsData);
    }

    useEffect(() => {
        initData();
    }, [])

    return (
        <div>
            <hr />
            {pastAlerts}
        </div>
    )
}
